import { cn } from '../lib/cn.js';

export interface ProcessingIndicatorProps {
  label: string;
  className?: string;
}

/** Pulsing dot shown while an AI step is running. */
export function ProcessingIndicator({ label, className }: ProcessingIndicatorProps) {
  return (
    <div
      className={cn(
        'inline-flex items-center gap-2 rounded-full border border-primary-border bg-primary-soft px-[15px] py-[9px]',
        className,
      )}
      role="status"
      aria-live="polite"
    >
      <span className="h-2 w-2 animate-kainos-pulse rounded-full bg-primary" aria-hidden="true" />
      <span className="text-[12.5px] font-semibold text-brand">{label}</span>
    </div>
  );
}
